import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CrmThemePalette } from '@shared/core/types';
import { registerTranslationsManually } from '@skyeng/libs/shared/i18n';
import { TranslocoService } from '@ngneat/transloco';

export class ConfirmDialogData {
  title?: string | null;
  content?: string | null;
  no?: string;
  yes?: string;
  yesButtonColor?: CrmThemePalette;
  selectButton?: 'yes' | 'no';
}

@Component({
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) @Optional() public data: ConfirmDialogData = {},
    private translocoService: TranslocoService,
  ) {}

  ngOnInit(): void {
    this.registerTranslations();
    this.setupData();
  }

  private registerTranslations(): void {
    registerTranslationsManually('confirmDialog', this.translocoService, import.meta.webpackContext!('./translation'));
  }

  private setupData(): void {
    this.data = {
      ...{
        title: this.translocoService.translate('confirmDialog.confirmDialog.areYouShure'),
        content: null,
        no: this.translocoService.translate('confirmDialog.confirmDialog.cancel'),
        yes: this.translocoService.translate('confirmDialog.confirmDialog.yes'),
        yesButtonColor: 'warn',
        selectButton: 'yes',
      },
      ...this.data,
    };
  }
}
